<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" fill="none" xmlns:v="https://vecta.io/nano">
		<path d="M1.13 13.59L6.71 8 1.13 2.41a1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0L8.9 7.36a.91.91 0 0 1 0 1.28L2.54 15a1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.41z" fill="currentColor" />
	</svg>
</template>
